import { StateObservable, combineEpics, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, first, groupBy, map, mergeMap, startWith } from 'rxjs/operators';
import { requestActions } from './apiHelpers';
import AppState from '../reducers/app-state';
import { ReduxAction } from '@repo/utils/types';
import { apiObservable } from '@repo/utils/helpers/api';
import { selectUser } from '../reducers/user/account';

/* Epic actions */
const locationActions = requestActions('LOCATION', ['fetch']);

/* Component actions */
export const fetchLocation = (location: string) => ({
  type: 'FETCH_LOCATION',
  payload: { location },
});

/* Epics */
const fetchLocationsEpic = (action$: Observable<ReduxAction>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType('FETCH_LOCATION'),
    groupBy(({ payload }) => payload.location),
    mergeMap((fetchesByLocation) =>
      fetchesByLocation.pipe(
        // Only fetch a given location's data once per user session
        first(),
        mergeMap(({ payload }) => {
          return apiObservable(
            'GET',
            `/locations/`,
            { query: { location: payload.location } },
            { noAuthorization: !selectUser(state$.value) },
          ).pipe(
            map((response) => {
              return locationActions['fetchSucceeded']({
                ...response,
                location: payload.location,
              });
            }),
            startWith(locationActions['fetchRequested'](payload)),
            catchError((err) => of(locationActions['fetchFailed'](err))),
          );
        }),
      ),
    ),
  );

export const locationsEpic = combineEpics(fetchLocationsEpic);
